import { initDateExtensions } from "./dateExtensions";
import { initStringExtensions } from "./stringExtensions";

const initExtensions = () => {
  initDateExtensions();
  initStringExtensions();
}

export default initExtensions;